var _ellipse, _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneratingPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 148,
    viewBox: "0 0 200 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.005,
    cy: 74,
    rx: 73.0897,
    ry: 73.077,
    fill: "#C1D3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_441_7284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.8506,
    y: 54.7343,
    width: 130.517,
    height: 35.8742,
    rx: 4,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.345 64.0349H100.879C99.3841 64.0349 98.1719 65.2469 98.1719 66.742C98.1719 68.2371 99.3841 69.449 100.879 69.449H124.345C125.84 69.449 127.052 68.2371 127.052 66.742C127.052 65.2469 125.84 64.0349 124.345 64.0349Z",
    fill: "#8BB1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.59 75.7655H100.879C99.3841 75.7655 98.1719 76.9775 98.1719 78.4726C98.1719 79.9676 99.3841 81.1796 100.879 81.1796H140.59C142.085 81.1796 143.298 79.9676 143.298 78.4726C143.298 76.9775 142.085 75.7655 140.59 75.7655Z",
    fill: "#C1D3F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4088 81.1797C87.1441 81.1797 90.9827 77.3417 90.9827 72.6073C90.9827 67.8729 87.1441 64.0349 82.4088 64.0349C77.6736 64.0349 73.835 67.8729 73.835 72.6073C73.835 77.3417 77.6736 81.1797 82.4088 81.1797Z",
    fill: "#5D8CEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2934 68.7802H81.1519V71.3505H78.5811V76.4912H83.7226V73.9209H86.2934V68.7802ZM83.7226 73.9209V71.3505H81.1519V73.9209H83.7226Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_441_7284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.9473,
    y: 95.9231,
    width: 130.517,
    height: 35.8742,
    rx: 4,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4414 105.224H61.9761C60.4808 105.224 59.2686 106.436 59.2686 107.931C59.2686 109.426 60.4808 110.638 61.9761 110.638H85.4414C86.9368 110.638 88.149 109.426 88.149 107.931C88.149 106.436 86.9368 105.224 85.4414 105.224Z",
    fill: "#8BB1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.687 116.954H61.9761C60.4808 116.954 59.2686 118.166 59.2686 119.661C59.2686 121.156 60.4808 122.368 61.9761 122.368H101.687C103.182 122.368 104.394 121.156 104.394 119.661C104.394 118.166 103.182 116.954 101.687 116.954Z",
    fill: "#C1D3F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5055 122.369C48.2407 122.369 52.0794 118.531 52.0794 113.796C52.0794 109.062 48.2407 105.224 43.5055 105.224C38.7703 105.224 34.9316 109.062 34.9316 113.796C34.9316 118.531 38.7703 122.369 43.5055 122.369Z",
    fill: "#5D8CEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3901 109.969H42.2485V112.539H39.6777V117.68H44.8193V115.11H47.3901V109.969ZM44.8193 115.11V112.539H42.2485V115.11H44.8193Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_441_7284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.9473,
    y: 13.5454,
    width: 130.517,
    height: 35.8742,
    rx: 4,
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4414 22.8461H61.9761C60.4808 22.8461 59.2686 24.0581 59.2686 25.5531C59.2686 27.0482 60.4808 28.2602 61.9761 28.2602H85.4414C86.9368 28.2602 88.149 27.0482 88.149 25.5531C88.149 24.0581 86.9368 22.8461 85.4414 22.8461Z",
    fill: "#8BB1FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.687 34.5767H61.9761C60.4808 34.5767 59.2686 35.7887 59.2686 37.2837C59.2686 38.7788 60.4808 39.9908 61.9761 39.9908H101.687C103.182 39.9908 104.394 38.7788 104.394 37.2837C104.394 35.7887 103.182 34.5767 101.687 34.5767Z",
    fill: "#C1D3F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5055 39.9908C48.2407 39.9908 52.0794 36.1529 52.0794 31.4185C52.0794 26.6841 48.2407 22.8461 43.5055 22.8461C38.7703 22.8461 34.9316 26.6841 34.9316 31.4185C34.9316 36.1529 38.7703 39.9908 43.5055 39.9908Z",
    fill: "#5D8CEC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3901 27.5913H42.2485V30.1617H39.6777V35.3024H44.8193V32.732H47.3901V27.5913ZM44.8193 32.732V30.1617H42.2485V32.732H44.8193Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_441_7284",
    x: 50.8506,
    y: 52.7343,
    width: 138.518,
    height: 43.8741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_7284"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_441_7284",
    result: "effect2_dropShadow_441_7284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_441_7284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_441_7284",
    x: 11.9473,
    y: 93.9231,
    width: 138.518,
    height: 43.8741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_7284"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_441_7284",
    result: "effect2_dropShadow_441_7284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_441_7284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_441_7284",
    x: 11.9473,
    y: 11.5454,
    width: 138.518,
    height: 43.8741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_7284"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_441_7284",
    result: "effect2_dropShadow_441_7284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_441_7284",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratingPlans);
export default __webpack_public_path__ + "static/media/generating_plans.7781e515b53d1187a6776e2150ec18ec.svg";
export { ForwardRef as ReactComponent };